import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../Components/ui/button/Button';

const SignUpPopup = () => {
  const [formData, setFormData] = useState({ firstName: '', email: '', password: '', toc: false });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      // Here you can handle the API response
      alert('Account created successfully!');
    }, 2000); // Simulating a 2-second API call
  };

  return !isLoading ? (
    <div className="flex flex-col gap-4 rounded-[16px] p-10">
      <h1 className="fredokaOne text-center text-[40px] font-normal leading-normal tracking-[-0.8px] text-[#012E33]">
        Create an Account
      </h1>
      <form className="space-y-3" onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            id="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-2 outline-none md:p-3"
          />
        </div>
        <div>
          <input
            type="email"
            id="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-2 outline-none md:p-3"
          />
        </div>
        <div>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-2 outline-none md:p-3"
          />
        </div>
        <Button label={'Create an Account'} className="w-full !p-1 md:p-3" type="submit" />
      </form>
      <div className="space-y-2">
        <div className="flex w-full items-center justify-center gap-3">
          <input
            className=""
            id="toc"
            type="checkbox"
            checked={formData.toc}
            onChange={handleChange}
          />
          <label
            htmlFor="toc"
            className="space-x-3 text-base font-normal leading-normal text-[#012E33]"
          >
            Accept Policies{' '}
            <Link to={'/tos'} className="text-[#FC823E] underline">
              Terms of use
            </Link>
            <Link to={'/privacy-policy'} className="text-[#FC823E] underline">
              Privacy Policy
            </Link>
          </label>
        </div>
        <p className="text-center text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#012E33]">
          Or continue using
        </p>
        <div className="text-center">
          <div className="flex flex-wrap justify-center gap-3 md:flex-nowrap">
            <button
              className={` fredoka mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#4285F4] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] md:w-full`}
            >
              <img src="/images/icons/social-icons/FacebookLogo.svg" alt="" /> Facebook
            </button>
            <button
              className={` fredoka  mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#DC4E41] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]  md:w-full`}
            >
              <img src="/images/icons/social-icons/GoogleLogo.svg" alt="" /> Google
            </button>
            <button
              className={`fredoka mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#000000] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]  md:w-full`}
            >
              <img src="/images/icons/social-icons/AppleLogo.svg" alt="" /> Apple
            </button>
          </div>
          <p className="font-fredoka mt-5 space-x-3 text-base font-semibold leading-normal text-[#012E33]">
            Already have an account?{' '}
            <Link to={'/login'} className="text-[#FC823E] hover:underline">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  ) : (
    <div className="flex w-full flex-col gap-4 rounded-[16px] p-5">
      <div className="flex h-[400px] w-full flex-col">
        <h2 className="fredokaOne text-center text-[40px] font-normal leading-normal tracking-[-0.8px] text-[#012E33]">
          Creating an account
        </h2>
        <div className="flex h-full w-full items-center justify-center">
          <img src="/images/gif/loading.gif" alt="loader" />
        </div>
      </div>
    </div>
  );
};

export default SignUpPopup;
